import { render, staticRenderFns } from "./ReviewAndSubmit.vue?vue&type=template&id=0f0c7b56&scoped=true"
import script from "./ReviewAndSubmit.vue?vue&type=script&lang=ts"
export * from "./ReviewAndSubmit.vue?vue&type=script&lang=ts"
import style0 from "./ReviewAndSubmit.vue?vue&type=style&index=0&id=0f0c7b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c7b56",
  null
  
)

export default component.exports